import React, {PropTypes} from 'react';
import CaseDataTableRow from './CaseDataTableRow';
//import * as pathConsts from '../../../constants/pathConstants';

const CaseDataTable = ({
  caseDatas,
  establishment_id,
  onSelect,
  onDelete
}) => {
  if (caseDatas) {
    return (
      <div className="case-data-container non-mobile">
        <table className="table">
          <thead>
            <tr>
              <th className="non-mobile"></th>
              <th className="non-mobile">Case Number</th>
              <th className="non-mobile">Job Title</th>
              <th className="non-mobile">Date of Injury or<br/>Onset of Illness</th>
              <th className="non-mobile">Where the event occurred</th>
              <th className="non-mobile">Most Serious Outcome</th>
              <th className="non-mobile">Number of days<br/>away from work</th>
              <th className="non-mobile">Number of days<br/>on job transfer<br/>or restriction</th>
              <th className="non-mobile">Injury Type</th>
              <th className="non-mobile"></th>
            </tr>
          </thead>
          <tbody>
            {
              // If there is case data in the array, loop and process.
              (caseDatas.length) ? (
                caseDatas.map((caseData) => {
                  let evenRow = caseDatas.indexOf(caseData) % 2;
                  return (<CaseDataTableRow
                    caseData={caseData}
                    establishment_id={establishment_id}
                    evenRow={evenRow}
                    onSelect={onSelect}
                    onDelete={onDelete}/>);
                })
              ):
              // else return empty row.
              (
                <tr>
                  <td colSpan="10">
                    There are no cases.
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <div className="casedata-container non-mobile">
        <table className="table">
          <thead>
            <tr>
              <th className="non-mobile"></th>
              <th className="non-mobile">Case Number</th>
              <th className="non-mobile">Job Title</th>
              <th className="non-mobile">Date of Injury or<br/>Onset of Illness</th>
              <th className="non-mobile">Where the event occurred</th>
              <th className="non-mobile">Most Serious Outcome</th>
              <th className="non-mobile">Number of days<br/>away from work</th>
              <th className="non-mobile">Number of days<br/>on job transfer<br/>or restriction</th>
              <th className="non-mobile">Injury Type</th>
              <th className="non-mobile"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="10">
                There are no cases
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
};

CaseDataTable.propTypes = {
  caseDatas: PropTypes.array.isRequired,
  establishment_id: PropTypes.number,
  onSelectAll: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectAllChecked: PropTypes.bool.isRequired,
  selectedCaseDatas: PropTypes.object.isRequired
};

export default CaseDataTable;



/** WEBPACK FOOTER **
 ** ./src/components/caseData/caseDataTable/CaseDataTable.js
 **/